export function planKbUploadBatch(files, knowledgeBases, orgInfo) {
  const selectedFiles = Array.from(files || []).filter(Boolean);
  const kbDocCapRaw = orgInfo?.plan_details?.kbDocs;
  const kbDocCap = Number(kbDocCapRaw);
  const hasKbDocCap = kbDocCapRaw != null && Number.isFinite(kbDocCap);
  const totalKbDocs = (Array.isArray(knowledgeBases) ? knowledgeBases : [])
    .reduce((sum, kb) => sum + (Number(kb?.docCount) || 0), 0);
  const docSlots = hasKbDocCap ? Math.max(0, kbDocCap - totalKbDocs) : selectedFiles.length;
  const filesToUpload = selectedFiles.slice(0, docSlots);
  return {
    filesToUpload,
    skippedForCap: selectedFiles.length - filesToUpload.length,
    docSlots,
    kbDocCap: hasKbDocCap ? kbDocCap : null,
    planName: orgInfo?.plan_details?.name || orgInfo?.plan || "current",
  };
}
